var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineSegments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4966_70694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 17.5C2.78726 17.5 1.66797 16.3807 1.66797 15C1.66797 13.6193 2.78726 12.5 4.16797 12.5C5.54868 12.5 6.66797 13.6193 6.66797 15C6.66797 16.3807 5.54868 17.5 4.16797 17.5Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.832 7.5C14.4513 7.5 13.332 6.38071 13.332 5C13.332 3.61929 14.4513 2.5 15.832 2.5C17.2127 2.5 18.332 3.61929 18.332 5C18.332 6.38071 17.2127 7.5 15.832 7.5Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 15H4.16536L15.832 5H10.4154",
    stroke: "#3D491F",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8543 4.33282L7.52101 2.99952C7.48932 2.96783 7.47154 2.92532 7.47154 2.88049V1.32305C7.47154 1.2303 7.39579 1.15532 7.30304 1.15532H6.1908C6.09805 1.15532 6.02307 1.2303 6.02307 1.32305V1.49928L4.57076 0.0492738C4.50506 -0.0164246 4.3984 -0.0164246 4.3327 0.0492738L0.049239 4.33274C0.00131712 4.38066 -0.0133687 4.45331 0.0129122 4.51592C0.0391912 4.57853 0.100254 4.61949 0.168271 4.61949H0.925732C1.01848 4.61949 1.09423 4.69524 1.09423 4.78799V8.16561C1.095 8.25836 1.17075 8.33333 1.26427 8.33333H3.22131C3.31407 8.33333 3.38904 8.25836 3.38904 8.16561V5.55156C3.39059 5.45804 3.46633 5.38307 3.55908 5.38307H5.3399C5.43343 5.38307 5.50917 5.45804 5.51072 5.55156V8.16561C5.51072 8.25836 5.58569 8.33333 5.67844 8.33333H7.63549C7.72901 8.33333 7.80476 8.25836 7.80553 8.16561V4.78799C7.80553 4.69524 7.88128 4.61949 7.97403 4.61949H8.73149C8.80028 4.62104 8.86289 4.58085 8.88994 4.51747C8.91699 4.45486 8.90308 4.38143 8.85438 4.33274L8.8543 4.33282Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 14.4151C12.1914 13.7113 13.0536 13.7113 13.8894 13.9488V11.393C13.0536 11.1554 12.1914 11.1554 11.25 11.8593V14.4151Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3516 12.3257C17.1874 12.5632 18.0496 12.5632 18.991 11.8594V14.4152C18.0496 15.1234 17.1874 15.119 16.3516 14.8859V12.3257Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3619 14.8862C15.5305 14.6487 14.7299 14.1868 13.8984 13.9492V16.6722C14.7299 16.9054 15.5305 17.3717 16.3619 17.6048V14.8862Z",
    fill: "#3D491F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 19.2497V11.8594",
    stroke: "#3D491F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 17.1384C14.0654 15.0268 16.1769 19.2499 18.9923 17.1384V11.8595C16.1769 13.9711 14.0654 9.74802 11.25 11.8595",
    stroke: "#3D491F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9923 14.4157C16.1769 16.5272 14.0654 12.3042 11.25 14.4157",
    stroke: "#3D491F",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4966_70694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineSegments);
export default __webpack_public_path__ + "static/media/LineSegments.0d3cba8dc014b4d787f42461191f73e7.svg";
export { ForwardRef as ReactComponent };